export default class Version { static version = 5.51; }